import { render, staticRenderFns } from "./sample-text-image-modal.vue?vue&type=template&id=ebbd1c98&"
import script from "./sample-text-image-modal.vue?vue&type=script&lang=js&"
export * from "./sample-text-image-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports